import Vue from 'vue';
import Router from 'vue-router';

import GeRen from '@/pages/GeRen';
import HelloWorld from '@/components/HelloWorld.vue';
import MobileHelloWorld from '@/pages/mobile/MobileHelloWorld'; // 假设你有一个专门用于手机端的页面组件
import MobilePage from '@/pages/mobile/MobilePage'; // 假设你有一个专门用于手机端的页面组件
import Chidao from '@/pages/mobile/ChiDao'
import kaoq from '@/pages/mobile/KaoQing'
Vue.use(Router);


 
// 桌面端路由规则
const pcRoutes = [
  {
    path: '/',
    component: HelloWorld,
    children: [
      {
        path: "/GeRen",
        name: "GeRen",
        component: GeRen,
        meta: { title: "打卡记录查询" }
      }
    ]
  }
];

//移动端路由规则
const mobileRoutes = [
  {
    path:'/',
    redirect: '/kaoq', // 重定向到访客预约页面
    component:MobileHelloWorld,
    children:[
      {
        path: "/kaoq",
        name: "kaoq",
        component: MobilePage,
        meta:{title:"考勤"}
      },
      {
        path: "/daka",
        name: "daka",
        component: kaoq,
        meta:{title:"打卡"}
      },
      
    ]
    
  },
  {
    path: '/chidao',
    name: 'chidao',
    component: Chidao
  },
]
// 判断设备类型
function isMobile() {
  return window.innerWidth < 768;
}

// 根据设备类型动态选择路由
const routes = isMobile() ? mobileRoutes : pcRoutes;

const router = new Router({
  mode: 'hash',
  routes
});


export default router;